<template>
  <div class="mt-3 lg:mt-6 mb-3">
    <div class="text-center text-xs text-gray-400" id="footer-notice-copyright">
      Copyright (C) 2022-{{ year() }} RED Engineering Design Ltd, version: v2.4.1 (Commit 365bfdc)
    </div>
  </div>
</template>
<script>
export default {
  name: 'FooterNotice',
  methods: {
    year() { return new Date().getFullYear(); }
  },
}
</script>
